import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CoreFeature } from "./data";

interface FeatureCardProps {
  feature: CoreFeature;
}

export function FeatureCard({ feature }: FeatureCardProps) {
  const Icon = feature.icon;
  return (
    <Card className={`border-none shadow-lg hover:shadow-xl transition-shadow ${feature.cardBgClass}`}>
      <CardHeader>
        <div
          className={`w-12 h-12 ${feature.iconBgClass} rounded-lg flex items-center justify-center mb-4`}
        >
          <Icon className={`w-6 h-6 ${feature.iconColorClass}`} />
        </div>
        <CardTitle className="text-xl">{feature.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-600">{feature.description}</p>
      </CardContent>
    </Card>
  );
}
